import React, { useState, useContext, useEffect } from 'react';
import { navigate } from 'hookrouter';

import VirtualScroller from '../components/crm/shared/VirtualScroller';
import { GetInitialSettings } from '../components/crm/requests/CommonRequests';
import { CalculateSettings } from '../components/crm/shared/Functions';
import { Header } from '../components/crm/shared/TableCells';
import ErrorPage from './error';

import { DataContext as DealDataContext } from '../stores/crm-deal-store';
import { DataContext } from '../stores/crm-active-deals-store';

const CrmActiveDeals = () => {
    const [error] = useState(null);
    const dealStore = useContext(DealDataContext);

    const {
        store: { layout, viewSettings },
    } = useContext(DataContext);

    const handleOnClick = (item) => {
        dealStore.dispatch({
            type: 'UPDATE_ACTIVE_DEAL',
            payload: item,
        });
        navigate('/crmDealDetails/' + item.id);
    };

    const content =
        error && error ? (
            <ErrorPage error={error} />
        ) : (
            <section className='w-100 crm-container'>
                <div className='d-flex'>
                    <div className='position-relative justify-content-left align-items-left'>
                        <div className='d-flex flex-column'>
                            <Header layout={layout} dataContext={DataContext} />
                            {viewSettings !== null ? <VirtualScroller dataContext={DataContext} onCellClick={handleOnClick} /> : null}
                        </div>
                    </div>
                </div>
            </section>
        );
    return content;
};

export default CrmActiveDeals;
